import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ObtenerConfiguracionSalesForceService} from '../../services/obtener-configuracion-sales-force.service';

let config: any;

export function inicializarConfiguracionSalesForceFactory(obtenerConfiguracionSalesForceService: ObtenerConfiguracionSalesForceService): any {
  const promise = obtenerConfiguracionSalesForceService.__invoke().then((configuracion) => {
  });
  return () => promise;
}

@NgModule({
  declarations: [],
  imports: []
})
export class ConfiguracionSalesForceModule {
  static forRoot(): any {
    return {
      ngModule: ConfiguracionSalesForceModule,
      providers: [
        ObtenerConfiguracionSalesForceService,
        {
          provide: APP_INITIALIZER,
          useFactory: inicializarConfiguracionSalesForceFactory,
          deps: [ObtenerConfiguracionSalesForceService],
          multi: true
        }
      ]
    };
  }
}
